import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import SearchComponent from '../../PricingHub/SearchComponent';

class UsageDetailSearchForm extends SearchComponent {
  searchInputs = [
    {
      label: 'label.startDate',
      name: 'startDate',
      type: 'date',
    },
    {
      label: 'label.endDate',
      name: 'endDate',
      type: 'date',
    },
    {
      label: 'label.ratingType',
      name: 'ratingType',
      type: 'select',
      tOptions: 'selections:recordIndicator',
      isClearable: true,
    },
    {
      label: 'label.source',
      name: 'source',
    },
    {
      label: 'label.batchId',
      name: 'batchId',
    },
    {
      label: 'label.provisioningId',
      name: 'provisioningId',
    },
    {
      label: 'label.status',
      name: 'status',
      type: 'select',
      tOptions: 'selections:usageRecStatus',
      isClearable: true,
    },
    {
      label: 'label.usageClass',
      name: 'usageClass',
    },
  ];

  btnSpan = 'col-md-12';
}

UsageDetailSearchForm.propTypes = {
  onSubmit: PropTypes.func,
  isSubmitting: PropTypes.bool,
};

UsageDetailSearchForm.defaultProps = {
  isSubmitting: false,
};

export default withTranslation('common')(UsageDetailSearchForm);
